import { render, staticRenderFns } from "./RelatedSearch.vue?vue&type=template&id=437d5690&scoped=true"
import script from "./RelatedSearch.vue?vue&type=script&lang=js"
export * from "./RelatedSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437d5690",
  null
  
)

export default component.exports